import { render } from "./browse_page.vue?vue&type=template&id=478a0110&scoped=true"
import script from "./browse_page.vue?vue&type=script&lang=js"
export * from "./browse_page.vue?vue&type=script&lang=js"

import "./browse_page.vue?vue&type=style&index=0&id=478a0110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-478a0110"]])

export default __exports__